import { create } from 'zustand';

interface NavMenuStore {
  isNavOpen: boolean;
  toggleNav: () => void;
}

export const useNavMenuStore = create<NavMenuStore>(set => ({
  isNavOpen: false,
  toggleNav: () => set(state => ({ isNavOpen: !state.isNavOpen })),
}));
